import { render, staticRenderFns } from "./emailNewslettersAutomated.vue?vue&type=template&id=7fbcd91d&scoped=true&"
import script from "./emailNewslettersAutomated.vue?vue&type=script&lang=js&"
export * from "./emailNewslettersAutomated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fbcd91d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VDialog,VFadeTransition,VSheet})
